(function () {

  function initHero(scope) {
    (scope || document).querySelectorAll('[data-pdpv3-hero]').forEach(function (root) {
      var main = root.querySelector('[data-pdpv3-hero-main]');
      var thumbs = root.querySelectorAll('[data-pdpv3-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.getAttribute('data-index');
          var template = root.querySelector('[data-pdpv3-hero-template="' + index + '"]');
          if (!template) return;
          main.innerHTML = template.innerHTML;
          thumbs.forEach(function (node) {
            node.classList.remove('is-active');
            node.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
        });
      });
    });
  }

  function initReadMore(scope) {
    (scope || document).querySelectorAll('[data-pdpv3-readmore-root]').forEach(function (root) {
      var content = root.querySelector('[data-pdpv3-readmore-content]');
      var toggle = root.querySelector('[data-pdpv3-readmore-toggle]');
      if (!content || !toggle) return;
      content.classList.add('is-clamped');
      if (toggle.getAttribute('aria-expanded') === 'true') {
        content.classList.remove('is-clamped');
      }
      var shouldShow = content.scrollHeight > content.clientHeight + 8;
      if (!shouldShow) {
        toggle.hidden = true;
        content.classList.remove('is-clamped');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = 'Read more';
        return;
      }
      toggle.hidden = false;
      if (toggle.dataset.pdpv3Bound === 'true') return;
      toggle.dataset.pdpv3Bound = 'true';
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        toggle.textContent = expanded ? 'Read more' : 'Read less';
        content.classList.toggle('is-clamped', expanded);
      });
    });
  }

  function initKlaviyoForms(scope) {
    (scope || document).querySelectorAll('[data-pdpv3-klaviyo-form-id]').forEach(function (trigger) {
      if (trigger.dataset.pdpv3KlaviyoBound === 'true') return;
      trigger.dataset.pdpv3KlaviyoBound = 'true';

      trigger.addEventListener('click', function (event) {
        var formId = (trigger.getAttribute('data-pdpv3-klaviyo-form-id') || '').trim();
        if (!formId) return;

        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });
  }

  function syncHeroSizing(scope) {
    (scope || document).querySelectorAll('[data-pdpv3-hero]').forEach(function (root) {
      var mainMedia = root.querySelector('[data-pdpv3-hero-main] .pdpv3-media');
      var thumbs = root.querySelector('.pdpv3-hero__thumbs');
      if (mainMedia) {
        var mainHeight = Math.round(mainMedia.getBoundingClientRect().height);
        if (mainHeight > 0) root.style.setProperty('--pdpv3-hero-main-height', mainHeight + 'px');
      }
      if (thumbs) {
        var thumbsHeight = Math.round(thumbs.getBoundingClientRect().height);
        if (thumbsHeight > 0) root.style.setProperty('--pdpv3-logo-row-height', thumbsHeight + 'px');
      }
    });
  }

  function initLightbox(scope) {
    var root = scope || document;
    var heroRoot = root.querySelector('[data-pdpv3-hero]') || document.querySelector('[data-pdpv3-hero]');
    var dialog = heroRoot ? heroRoot.querySelector('[data-pdpv3-lightbox]') : document.querySelector('[data-pdpv3-lightbox]');
    if (!dialog) return;
    var mediaWrap = dialog.querySelector('[data-pdpv3-lightbox-media]');
    var close = dialog.querySelector('[data-pdpv3-lightbox-close]');
    var prev = dialog.querySelector('[data-pdpv3-lightbox-prev]');
    var next = dialog.querySelector('[data-pdpv3-lightbox-next]');
    var templates = heroRoot ? heroRoot.querySelectorAll('[data-pdpv3-lightbox-template]') : document.querySelectorAll('[data-pdpv3-lightbox-template]');
    if (!mediaWrap || !close || !templates.length) return;

    var current = 0;
    var total = templates.length;
    var touchStartX = null;

    function render(index) {
      current = (index + total) % total;
      var tpl = heroRoot ? heroRoot.querySelector('[data-pdpv3-lightbox-template="' + current + '"]') : document.querySelector('[data-pdpv3-lightbox-template="' + current + '"]');
      if (!tpl) return;
      mediaWrap.innerHTML = tpl.innerHTML;
    }

    root.querySelectorAll('[data-pdpv3-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var index = Number(trigger.getAttribute('data-index') || 0);
        render(index);
        if (!dialog.open) dialog.showModal();
      });
    });

    close.addEventListener('click', function () {
      dialog.close();
    });
    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        render(current - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        render(current + 1);
      });
    }

    close.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    dialog.addEventListener('keydown', function (event) {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        render(current - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        render(current + 1);
      }
    });

    dialog.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    });
    dialog.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) render(current + 1);
        if (delta > 0) render(current - 1);
      }
      touchStartX = null;
    });

    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    });
  }

  function syncEditorialSizing(scope) {
    (scope || document).querySelectorAll('.pdpv3-editorial__layout').forEach(function (layout) {
      var copy = layout.querySelector('.pdpv3-editorial__copy');
      var content = layout.querySelector('.pdpv3-editorial__content');
      var media = layout.querySelector('.pdpv3-editorial__media');
      var heading = layout.querySelector('.pdpv3-editorial__heading');
      if (!copy || !content) return;
      content.style.removeProperty('--pdpv3-editorial-clamp-height');
      if (!media || window.innerWidth <= 989) return;

      var mediaHeight = Math.round(media.getBoundingClientRect().height);
      if (mediaHeight <= 0) return;

      var headingHeight = 0;
      if (heading) {
        var headingStyles = window.getComputedStyle(heading);
        headingHeight = Math.ceil(heading.getBoundingClientRect().height + parseFloat(headingStyles.marginBottom || '0'));
      }

      var clampHeight = mediaHeight - headingHeight;
      if (clampHeight > 80) {
        content.style.setProperty('--pdpv3-editorial-clamp-height', clampHeight + 'px');
      }
    });
  }

  function init(scope) {
    initHero(scope);
    initKlaviyoForms(scope);
    syncEditorialSizing(scope);
    initReadMore(scope);
    initLightbox(scope);
    syncHeroSizing(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', function () {
    syncHeroSizing(document);
    syncEditorialSizing(document);
    initReadMore(document);
  });

  window.addEventListener('load', function () {
    syncHeroSizing(document);
    syncEditorialSizing(document);
    initReadMore(document);
  });
})();
